function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "audiobook_svg__cls-2",
  d: "M101.41 104.55c-1.62 0-2.93-1.31-2.93-2.93V66.27c0-17.88-14.54-32.42-32.42-32.42S33.64 48.39 33.64 66.27v35.35c0 1.62-1.31 2.93-2.93 2.93s-2.93-1.31-2.93-2.93V66.27c0-21.11 17.17-38.28 38.28-38.28s38.28 17.17 38.28 38.28v35.35c0 1.62-1.31 2.93-2.93 2.93z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "audiobook_svg__cls-2",
  d: "M30.55 104.55c-11 0-19.95-8.95-19.95-19.95s8.95-19.95 19.95-19.95c1.62 0 2.93 1.31 2.93 2.93s-1.31 2.93-2.93 2.93c-7.77 0-14.09 6.32-14.09 14.09s6.32 14.09 14.09 14.09c1.62 0 2.93 1.31 2.93 2.93s-1.31 2.93-2.93 2.93zM101.99 104.55c-1.62 0-2.93-1.31-2.93-2.93s1.31-2.93 2.93-2.93c7.77 0 14.09-6.32 14.09-14.09s-6.32-14.09-14.09-14.09c-1.62 0-2.93-1.31-2.93-2.93s1.31-2.93 2.93-2.93c11 0 19.95 8.95 19.95 19.95s-8.95 19.95-19.95 19.95z"
});

function SvgAudiobook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "audiobook_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3);
}

export default SvgAudiobook;